var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgEditAvatar(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("circle", { cx: 17.5, cy: 17.5, r: 17.5, fill: "#4DABF7" }),
        React.createElement("path", { d: "M12 21.5V24h2.5l7.373-7.373-2.5-2.5L12 21.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z", fill: "#fff" })));
}
export default SvgEditAvatar;
//# sourceMappingURL=EditAvatar.js.map